import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const API_BASE = 'https://rbuymart.rbhardwaj.com/server/api/admin';

export const fetchAdminDashboardDashboardStats = createAsyncThunk(
    'admin/fetchDashboardStats',
    async (_, { rejectWithValue }) => {
        try {
            const response = await fetch(`${API_BASE}/analytics.php`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                }
            });
            const data = await response.json();
            if (!response.ok) return rejectWithValue(data.message);
            return data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);

const adminSlice = createSlice({
    name: 'admin',
    initialState: { dashboardStats: null, loading: false, error: null },
    reducers: { purgeAdminMetricsState: (state) => { state.dashboardStats = null; } },
    extraReducers: (builder) => {
        builder
            .addCase(fetchAdminDashboardDashboardStats.pending, (state) => { state.loading = true; state.error = null; })
            .addCase(fetchAdminDashboardDashboardStats.fulfilled, (state, action) => {
                state.loading = false;
                state.dashboardStats = action.payload;
            })
            .addCase(fetchAdminDashboardDashboardStats.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    }
});

export const { purgeAdminMetricsState } = adminSlice.actions;
export default adminSlice.reducer;